import {ErrorData,ErrorType} from "./types";

const ErrorHandler = {

    getHttpStatus : function(err : any) : number{
        // console.log(err);
        let statusCode : number = 0;
        if( err.status ){
            statusCode = err.status;
        }
        else if( err.response && err.response.status ){
            statusCode = err.response.status;
        }
        else if( err.status === null ){
            statusCode = 500;
        }
        else{
            //This is a javascript error
            statusCode = 500;
        }
        return statusCode;
    },

    isNetworkError: function(err : any): boolean {
        return err && err.message.toLowerCase()  === "network error";
    },

    /**
     * @returns
     *  - true: stating that the flow must continue.
     *  - false: a redirection was done, stop with current flow.
     */
    handleLoggedOutError : function(error : any) : boolean {
        if ( error ) {
            // Request made and server responded
            const statusCode = this.getHttpStatus(error);
            if( statusCode === 403 || statusCode === 401 ){
                window.alert("Your session has expired. You will be redirected to the login page.");

                let currentLocation = window.location.href;
                window.location.href = process.env.REACT_APP_LOGIN_REDIRECT.replace("{REDIRECT_URL}", encodeURIComponent(currentLocation));
                return true;
            }
        }
        return false;
    },

    getErrorMessage : function(error : any) : ErrorData {
        console.log(error);

        const errorMessage : ErrorData = {
            msg : "",
            type : ErrorType.exception
        };


        if (error.response) {
            
            //AXIOS REQUEST + RESPONSE

            console.log("AXIOS REQUEST + RESPONSE");

            const statusCode = this.getHttpStatus(error);
            if( statusCode >= 500 ){
                if( error.response.data ){
                    if( typeof error.response.data === 'string' && error.response.data.includes("ECONNREFUSED")){
                        errorMessage.msg = "There was an error connecting to our servers";
                    }
                    else {
                        errorMessage.msg = "There was an error in our servers.";
                    }
                }
                else {
                    errorMessage.msg = error.message;
                }
                errorMessage.type = ErrorType.exception;
            }
            else if( statusCode >= 400 ){
                if( error.response.data ){
                    errorMessage.msg = "There was an error sending data to our servers.";
                }
                else {
                    errorMessage.msg = error.message;
                }
                errorMessage.type = ErrorType.exception;
            }
            else if( statusCode >= 300 ){
                if( error.response.data ){
                    errorMessage.msg = "There was an error with the data to our servers.";
                }
                else {
                    errorMessage.msg = error.message;
                }
                errorMessage.type = ErrorType.warning;
            }
        } else if (error.request) {
            // The request was made but no response was received
            console.log("The request was made but no response was received");
            errorMessage.msg = error.message;
        } else {
            console.log("Something happened in setting up the request that triggered an Error");
            errorMessage.msg = error.message;
        }


        // const element = <AlertDismissible message={msg} serverMessage={serverMessage} variant={variant} setErrors={setErrors}/>;
        // let errorsArray = [];
        // errorsArray.push(element);
        // setErrors(errorsArray);
        return errorMessage;
    }

};

export default ErrorHandler;

// import AlertDismissible from "../components/AlertDismissible";
// let ErrorHandler = {
//     getHttpStatus : function(err : any) : number{
//         // console.log(err);
//         let statusCode : number = 0;
//         if( err.status ){
//             statusCode = err.status;
//         }
//         else if( err.response && err.response.status ){
//             statusCode = err.response.status;
//         }
//         else if( err.status === null ){
//             statusCode = 500;
//         }
//         else{
//             //This should not happen, let's assume 500.
//             statusCode = 500;
//         }  
//         // console.log("statusCode:",statusCode);
//         return statusCode;      
//     },
//     showError : function(err : any, entity : string, setErrors : any){
//         console.log(err, entity);
//         let hasResponseObj : boolean = err.response !== undefined;
//         let statusCode = this.getHttpStatus(err);
//         let msg = "";
//         let serverMessage = "";
//         let variant = "danger";
//         if( statusCode == 403){
//             window.alert("Your session has expired. You will be redirected to the login page.");
//             let currentLocation = window.location.href;
//             window.location.href = process.env.REACT_APP_LOGIN_REDIRECT.replace("{REDIRECT_URL}", encodeURIComponent(currentLocation));
//             return;
//         }
//         else if( statusCode >= 500 ){
//             if( hasResponseObj && err.response.data ){
//                 if( typeof err.response.data === 'string' && err.response.data.includes("ECONNREFUSED")){
//                     msg = "There was an error connecting to our servers, retrieving: '" + entity + "' data. Try reloading the page or contact support.";
//                 }
//                 else {
//                     msg = "There was an error in our servers, retrieving: " + entity + " data. Try reloading the page or contact support.";
//                     if( err.response.data && err.response.data.errMessage ){
//                         serverMessage = ". The server says: '" + err.response.data.errMessage + "'. ID: " + + err.response.data.logId;
//                     }
//                 }
//             }
//             else {
//                 msg = err.message;
//             }
//         }
//         else if( statusCode >= 400 ){
//             if( hasResponseObj &&  err.response.data ){
//                 msg = "There was an error sending data to our servers, while retrieving: '" + entity + "' data";
//                 if( err.response.data && err.response.data.errMessage ){
//                     serverMessage = ". The server says: '" + err.response.data.errMessage + "'. ID: " + + err.response.data.logId;
//                 }
//             }
//             else {
//                 msg = err.message;
//             }
//             variant = "warning";
//         }
//         else if( statusCode >= 300 ){
//             if(  hasResponseObj && err.response.data ){
//                 msg = "There was an error with the data to our servers. '" + entity + "' data";
//                 if( err.response.data && err.response.data.errMessage ){
//                     serverMessage = ". The server says: '" + err.response.data.errMessage + "'. ID: " + + err.response.data.logId;
//                 }            
//             }
//             else {
//                 msg = err.message;
//             }
//             variant = "warning";
//         }
//         const element = <AlertDismissible message={msg} serverMessage={serverMessage} variant={variant} setErrors={setErrors}/>;
//         let errorsArray = [];
//         errorsArray.push(element);
//         setErrors(errorsArray);
//     }
// };
// export default ErrorHandler;